export const TopMenu = [
  {
    formId: "carrier",
    menus: [
      {
        id: 1,
        label: "Download Template",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "primary",
        to: "Template",
      },
      {
        id: 2,
        label: "Import Carrier",
        verient: "outlined",
        icon: "fa-solid fa-upload",
        color: "warning",
        to: "Import",
      },
      {
        id: 3,
        label: "Create New Carrier",
        verient: "contained",
        icon: "fa-solid fa-plus",
        color: "success",
        to: "form",
      },
    ],
  },
  {
    formId: "trailer",
    menus: [
      {
        id: 1,
        label: "Download Template",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "primary",
        to: "Template",
      },
      {
        id: 2,
        label: "Import Trailer",
        verient: "outlined",
        icon: "fa-solid fa-upload",
        color: "warning",
        to: "Import",
      },
      {
        id: 3,
        label: "Export to excel",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "error",
        to: "Export",
      },
      {
        id: 4,
        label: "Add Trailer",
        verient: "contained",
        icon: "fa-solid fa-plus",
        color: "success",
        to: "form",
      },
    ],
  },
  {
    formId: "vehicle",
    menus: [
      {
        id: 1,
        label: "Download Template",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "primary",
        to: "Template",
      },
      {
        id: 2,
        label: "Import Vehicle",
        verient: "outlined",
        icon: "fa-solid fa-upload",
        color: "warning",
        to: "Import",
      },
      {
        id: 3,
        label: "Export to excel",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "error",
        to: "Export",
      },
      {
        id: 4,
        label: "Add Vehicle",
        verient: "contained",
        icon: "fa-solid fa-plus",
        color: "success",
        to: "form",
      },
    ],
  },
  {
    formId: "drivers",
    menus: [
      {
        id: 1,
        label: "Download Template",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "primary",
        to: "Template",
      },
      {
        id: 2,
        label: "Import Driver",
        verient: "outlined",
        icon: "fa-solid fa-upload",
        color: "warning",
        to: "Import",
      },
      {
        id: 3,
        label: "Export to excel",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "error",
        to: "Export",
      },
      {
        id: 4,
        label: "Add Driver",
        verient: "contained",
        icon: "fa-solid fa-plus",
        color: "success",
        to: "form",
      },
    ],
  },
  {
    formId: "load",
    menus: [
      {
        id: 1,
        label: "Export to excel",
        verient: "outlined",
        icon: "fa-solid fa-download",
        color: "error",
        to: "Export",
      },
      {
        id: 2,
        label: "Create Load",
        verient: "contained",
        icon: "fa-solid fa-plus",
        color: "success",
        to: "form",
      },
    ],
  },
];
